import { colors } from "../../Styles";

export function AnimalMove({size = "20px", fillColor = colors.greyLightTertiary}) {
  return (
    <svg height={size} width={size} fill={fillColor} xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 283.46 283.46">
      <path d="M231.18,233.86s51.74-108.16-63.33-144.06c0,0,10.71-38.82,58.87-47.28,38.95-6.84,28.54-24.98,28.54-24.98,0,0,54.41,41.93-4.46,94.55,0,0,36.4,93.58-19.62,121.76Z"/>
      <path d="M56.06,233.86S-5.27,125.7,119.4,89.8c0,0-10.71-38.82-58.87-47.28-38.95-6.84-28.54-24.98-28.54-24.98,0,0-54.41,41.93,4.46,94.55,0,0-36.4,93.58,19.62,121.76Z"/>
      <polygon points="215.24 192.17 145.73 152.03 145.73 174.67 81.96 174.67 81.96 209.67 145.73 209.67 145.73 232.3 215.24 192.17"/>
    </svg>
  );
}
